import { render } from "./OwnerAddEmployeePanel.vue?vue&type=template&id=59098a3a&scoped=true"
import script from "./OwnerAddEmployeePanel.vue?vue&type=script&lang=js"
export * from "./OwnerAddEmployeePanel.vue?vue&type=script&lang=js"

import "./OwnerAddEmployeePanel.vue?vue&type=style&index=0&id=59098a3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59098a3a"]])

export default __exports__